<template>
    <div class="relative mb-2 group" @click="() => emits('handleClick')">
        <div
            class="h-8 w-8 bg-gray-300 rounded-full flex items-center justify-center group-hover:scale-125 transition-all duration-300"
        >
            <fa :icon="['fal', 'users']" class="!text-lg text-white" />
        </div>

        <div class="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 flex items-center">
            <div
                v-for="(contact, index) in contacts.slice(0, 5)"
                class="h-5 w-5 rounded-full flex items-center justify-center border border-white"
                :key="index"
                style="font-size: 8px"
                :class="[
                    contact.badge,
                    index !== 0 ? '-ml-[10px]' : '',
                    index === 4 ? '!bg-white !border-gray-300' : '',
                ]"
            >
                {{ index === 4 ? `+${contacts.length - 4}` : contact.initials }}
            </div>
        </div>
    </div>
</template>

<script setup>
const emits = defineEmits(["handleClick"]);
const props = defineProps({
    contacts: {
        type: Array,
        default: [],
    },
});
</script>
